module.exports = __webpack_public_path__ + "img/pizza_strada_960px.04ab3b72.jpg";